import { render, staticRenderFns } from "./GroupCrud.vue?vue&type=template&id=315446e2&scoped=true"
import script from "./GroupCrud.vue?vue&type=script&lang=js"
export * from "./GroupCrud.vue?vue&type=script&lang=js"
import style0 from "./GroupCrud.vue?vue&type=style&index=0&id=315446e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315446e2",
  null
  
)

export default component.exports